/**
 * Voile opaque qui couvre la zone status bar (Dynamic Island / encoche iPhone)
 * pour empêcher le contenu scrollé de transparaître derrière les icônes système
 * en mode PWA standalone ou Safari avec viewport-fit=cover.
 *
 * - Sur desktop et mobile sans encoche : env(safe-area-inset-top) = 0px → invisible
 *   (progressive enhancement, zéro impact).
 * - z-[60] : au-dessus des Sheet/Dialog overlays (z-50) pour rester opaque
 *   pendant qu'une modale est ouverte. Sous Sonner (z-[9999] par défaut).
 * - pointer-events-none + aria-hidden : purement décoratif, invisible aux SR
 *   et aux clics.
 */
export function SafeAreaTopVeil() {
    return (
        <div
            aria-hidden
            className="fixed top-0 inset-x-0 z-[60] bg-background pointer-events-none"
            style={{ height: 'env(safe-area-inset-top)' }}
        />
    )
}
